import { useMutation } from "@tanstack/react-query";

import { onToast } from "@components/Toast";

import { processRequest } from "@api/config";
import { TTipMenuData, tipMenuAPI } from "@api/tipMenu";

import { tipMenuEnabledStorage } from "@storage/sessionStorage";

import { useAuthQuery } from "@lib/queryClient";

import { API_PREFIXES, QUERY_KEYS } from "@configs/api";

export const useTipMenuStatusQuery = () => {
	const query = useAuthQuery({
		queryKey: [QUERY_KEYS.TIP_MENU_STATUS],
		queryFn: async () => {
			const data = await processRequest({
				prefix: API_PREFIXES.GET_TIP_MENU_STATUS,
				request: (token) => tipMenuAPI.getTipMenuStatus({ token }),
			});

			return data;
		},
	});

	if (query.isSuccess) {
		tipMenuEnabledStorage.setItemAsJson<boolean>(query.data.enabled);
	}

	return query;
};
export const useToggleTipMenuStatusMutation = () =>
	useMutation({
		mutationFn: async (enabled: boolean) => {
			await processRequest({
				prefix: API_PREFIXES.TOGGLE_TIP_MENU_STATUS,
				request: (token) => tipMenuAPI.toggleTipMenuStatus({ token, enabled }),
			});
		},
	});

export const useGetTipMenuDataQuery = () =>
	useAuthQuery({
		queryKey: [QUERY_KEYS.TIP_MENU_DATA],
		queryFn: async () => {
			const data = await processRequest({
				prefix: API_PREFIXES.GET_TIP_MENU_DATA,
				request: (token) => tipMenuAPI.getTipMenuData({ token }),
			});

			return data;
		},
	});

export const useUpdateTipMenuDataMutation = () =>
	useMutation({
		mutationFn: async (items: TTipMenuData) => {
			await processRequest({
				prefix: API_PREFIXES.UPDATE_TIP_MENU_DATA,
				request: (token) => tipMenuAPI.updateTipMenuData({ token, items }),
			});
		},
		onSuccess: () => {
			onToast({ message: "Attention", description: "The changes have been successfully saved" });
		},
	});

export const useDeleteTipMenuItemMutation = () =>
	useMutation({
		mutationFn: async (id: number) => {
			await processRequest({
				prefix: API_PREFIXES.DELETE_TIP_MENU_ITEM,
				request: (token) => tipMenuAPI.deleteTipMenuItem({ id, token }),
			});
		},
	});
